import ApiExecute from ".";

const view = async (data = null) => {
  let params = "";
  if (data) {
    params = "?" + new URLSearchParams(data).toString();
  }
  return await ApiExecute(`material-type${params}`, {
    data,
  });
};

const store = async (data) => {
  return await ApiExecute("material-type", {
    method: "POST",
    data,
  });
};

const show = async (id) => {
  return await ApiExecute(`material-type/${id}`);
};

const update = async (id, data) => {
  data._method = "PUT";
  return await ApiExecute(`material-type/${id}`, {
    method: "POST",
    data,
  });
};

const destory = async (id) => {
  return await ApiExecute(`material-type/${id}`, {
    method: "POST",
    data: {
      _method: "DELETE",
    },
  });
};

const materialTypeServices = {
  view,
  store,
  show,
  update,
  destory,
};

export default materialTypeServices;
